import { Button, Modal } from "@/components/ui";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { LoginRequestInit } from "@/model/request/auth/LoginRequest";
import { RouteConstant } from "@/util/constant/RouteConstant";
import { loginSchema } from "@/utilities/validation/authSchema";
import { useState } from "react";
import { Textfield } from "@/components/ui/input/textfield";
import { EyeClosed, EyeIcon } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/store";
import { workspace } from "@/store/modules/workspace";
import { auth } from "@/store/modules/auth.ts";
import { application } from "@/store/modules/application";

export const LoginForm = () => {
  const [seePassword, setSeePassword] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [response, setResponse] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const authState = useSelector((state: RootState) => state.auth);

  function handleSubmit(value) {
    dispatch(auth.action.login(value)).then((result) => {
      if (result.payload.responseCode == "00") {
        dispatch(application.action.readApplication());
        dispatch(
          workspace.action.readWorkSpaceByUserId({
            userId: result.payload.userId,
          })
        );
        navigate(RouteConstant.dashboard.dashboard.path);
      } else {
        setModalVisible(true), setResponse(result.payload.responseMessage);
      }
    });
  }
  const getErrorMessage = (error: any): string | undefined => {
    if (typeof error === 'string') {
      return error;
    }
    if (Array.isArray(error)) {
      return error[0]; // Return first error if it's an array
    }
    return undefined;
  };
  const navigate = useNavigate();
  const authGithub = () => {
    window.location.href = `https://3gtiecsm6jguvxl777ino6jdqa0vftld.lambda-url.us-east-1.on.aws/auth/github/login`;
  };

  const formik = useFormik({
    initialValues: LoginRequestInit,
    onSubmit: handleSubmit,
    validationSchema: loginSchema,
  });

  return (
    <div className="p-5 space-y-5">
      <Textfield
        label="Email"
        name={"userEmail"}
        formik={formik}
        error={typeof formik.errors.userEmail === 'string' ? formik.errors.userEmail : undefined}
        type="email"
        placeholder="Enter your email"
      />
      <div>
        <Textfield
          label="Password"
          placeholder="Enter your password"
          name="userPassword"
          formik={formik}
          error={formik?.touched.userPassword && formik?.errors.userPassword 
            ? getErrorMessage(formik.errors.userPassword) 
            : undefined}
          type={seePassword ? "text" : "password"}
          suffixIcon={
            <button onClick={() => setSeePassword((prev) => !prev)}>
              {seePassword ? (
                <EyeClosed color = "black" />
              ) : (
                 
                  <EyeIcon color="black" />
              )}
            </button>
          }
          
        />
        <p
          className="right-0 w-full justify-end mt-2 flex text-sm text-tertiary cursor-pointer"
          onClick={() => navigate(RouteConstant.auth.reset.path)}
        >
          Forgot Password
        </p>
      </div>
      <Button
        type="submit"
        label="Login"
        className="w-full mt-5"
        state="primary"
        isLoading={authState.loading}
        disabled={authState.loading||!formik.isValid}
        onClick={() => {
          formik.handleSubmit();
        }}
      />
      {/* <div className="flex items-center w-full max-w-md gap-3 py-2">
        <hr className="flex-grow border-white" />
        <span className="text-sm text-tertiary">or</span>
        <hr className="flex-grow border-white" />
      </div>
      <Button
        type="submit"
        label="Sign in with Github"
        className="w-full mt-5"
        state="tertiary"
        onClick={() => authGithub()}
        prefixIcon={<FaGithub />}
      /> */}
      <Modal
        title="Sign In Failed"
        text={response}
        type="error"
        modal={modalVisible}
        onClose={() => setModalVisible(false)}
        buttonLabel="Close"
        onClick={() => setModalVisible(false)}
      />
    </div>
  );
};
